const searchInput = {
    props: {
        value: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Search...",
        },
        inputId: {
            type: String,
            default: "search-input",
        },
        placeholder: {
            type: String,
            default: "Search...",
        },
        minCharacters: {
            type: Number,
            default: 3,
        },
        maxCharacters: {
            type: Number,
            default: 50,
        },
        delaytime: {
            type: Number,
            default: 500,
        },
        autocompleteHandler: {
            type: String,
            default: "",
        },
        buttonType: {
            type: String,
            default: "submit",
        },
        buttonText: {
            type: String,
            default: "search",
        },
        clearText: {
            type: String,
            default: "clear search",
        },
        name: {
            type: String,
            default: "search-input-field",
        },
        errorLength:{
            type: String,
            default: 'Error'
        },
        errorRequired:{
            type: String,
            default: 'Error'
        }
    },
    data() {
        return {
            search: "",
            debounceTimer: 0,
            startSearch: false,
        };
    },
    template: `<div class="input-search-wrap" :class="activeClass" @click="stopPropagate">
        <div class="input-search" :class="activeClass" >
            <input 
                type="search" 
                @focus="onFocus"
                @input="triggerOnInput"
                @searchFailed=""
                :name="name"
                ref="searchInput"
                v-model="search" 
                :id="inputId" 
                :aria-label="label"
                :placeholder="placeholder"

                data-val="true"
                :data-val-length="errorLength"
                :data-val-required="errorRequired"
                :data-val-length-max="maxCharacters"
                :data-val-length-min="minCharacters"

                class="form-control form-control--lg">
            
            <div class="input-search__cta">

                <button :disabled="searchBtnDisabled" type="button" @click="clearInput" :aria-controls="inputId" class="btn--clear">
                    <span>{{clearText}}</span>
                </button>

                <button :disabled="searchBtnDisabled" :type="buttonType" class="btn--search">
                    <span>{{buttonText}}</span>
                </button>

            </div>

            <b-auto-completer ref="autocompleter" v-if="autocompleteHandler!=='' && startSearch" 
                :handler="autocompleteHandler" 
                :value="search"
                @searchFailed="searchFailed"
                @searchCompleted="searchCompleted"
                @closeAutocomplete="closeAutocomplete">
            </b-auto-completer>

        </div>
        
        <div>
            <span class="field-validation-valid error-message" :data-valmsg-for="name" data-valmsg-replace="true"></span>
        </div>
    </div>`,
    mounted() {
        this.search = this.value

        // this.$slots.default().forEach(vnode => { 
        //      console.log(vnode.tag)
        // })

        //console.log(this.$slots.default()[0].el)

        
    },
    computed: {
        activeClass() {
            if (this.search.length) {
                return "input-search--active";
            }
            return "";
        },
        searchBtnDisabled() {
            if (this.search.length > 0) {
                return false;
            }
            return true;
        },
    },
    methods: {
        onFocus(){
            this.checkToSearch()
        },
        triggerOnInput() {
            this.$emit("change", this.search);

            clearTimeout(this.debounceTimer);

            this.debounceTimer = setTimeout(() => {
                this.checkToSearch()
            }, this.delaytime);

        },
        checkToSearch(){
            if (this.search.length >= this.minCharacters) {
                this.doSearch();
            }
        },
        stopSearch() {
            this.startSearch = false;
            this.$emit("searchStopped", this.search);
        },
        doSearch() {
            this.startSearch = true;
            
            this.$emit("searching", this.search);

            this.$nextTick(() =>  this.$refs["autocompleter"].doSearch() )
        },
        clearInput() {
            this.search = "";
            this.stopSearch();
            this.$emit("clear");
        },
        setFocus() {
            this.$nextTick(() => this.$refs.searchInput.focus());
        },
        searchFailed(messages) {
            this.$emit("searchFailed", messages)
        },
        searchCompleted() {
            
        },
        closeAutocomplete(){
            this.startSearch = false;
        },
        stopPropagate(e){
            e.stopPropagation()
        }
    },
};
